import React from 'react';
import { Page, TabbedLayout } from '@backstage/core-components';
import { useParams } from 'react-router-dom';
import { Header } from '@internal/plugin-components-react';
import { EntityGluesServiceConfigContent } from '@internal/backstage-plugin-glues-management';

const DeploymentConfig = ({
  environmentId,
  applicationId,
}


) => (
  React.createElement(TabbedLayout, null
    , React.createElement(TabbedLayout.Route, { path: "/", title: "Deployment Config" ,}
      , React.createElement(EntityGluesServiceConfigContent, {
        application: applicationId,
        environment: environmentId,}
      )
    )
  )
);

const GluesManagementPage = ({
  environmentId,
  applicationId,
  header,
}



) => {
  return (
    React.createElement(Page, { themeId: "service",}
      , header
      , React.createElement(DeploymentConfig, {
        applicationId: applicationId,
        environmentId: environmentId,}
      )
    )
  );
};

export const EnvGluesManagementPage = () => {
  const { environmentId, applicationId } = useParams();

  return (
    React.createElement(GluesManagementPage, {
      header: 
        React.createElement(Header, {
          title: applicationId,
          breadcrumbItems: [
            {
              text: 'Environment Management',
              href: '/cluster-management/environments',
            },
            {
              text: environmentId,
              href: `/cluster-management/environments/${environmentId}`,
            },
          ],}
        )
      ,
      applicationId: applicationId,
      environmentId: environmentId,}
    )
  );
};

export const AppGluesManagementPage = () => {
  const { environmentId, applicationId } = useParams();

  return (
    React.createElement(GluesManagementPage, {
      header: 
        React.createElement(Header, {
          title: environmentId,
          breadcrumbItems: [
            {
              text: 'App Management',
              href: '/cluster-management/applications',
            },
            {
              text: applicationId,
              href: `/cluster-management/applications/${applicationId}`,
            },
          ],}
        )
      ,
      applicationId: applicationId,
      environmentId: environmentId,}
    )
  );
};
